import { Action, createReducer, on } from '@ngrx/store';
import { WorkflowOrigin, WorkflowStep, WorkflowStepType, WorkflowType } from '@warema/shared/models';
import * as WorkflowActions from './workflow.actions';

export const WORKFLOW_FEATURE_KEY = 'workflow';

export interface WorkflowState {
    steps: Array<WorkflowStep>;
    activatedStep: WorkflowStepType | null;
    previouslyActivatedStep: WorkflowStepType | null;
    workflowOrigin: WorkflowOrigin | null;
    workflowType: WorkflowType | null;
}

const initialState: WorkflowState = {
    steps: [],
    activatedStep: null,
    previouslyActivatedStep: null,
    workflowOrigin: WorkflowOrigin.WaremaPlusDefault,
    workflowType: null,
};

export const workflowReducer = createReducer(
    initialState,

    on(
        WorkflowActions.InitializeWorkflow,
        (state, { steps, stepType, workflowOrigin, workflowType }): WorkflowState => {
            stepType ??= steps[0].workflowStepType;
            const stepNumber = steps.findIndex(x => x.workflowStepType === stepType);
            return {
                ...state,
                steps,
                activatedStep: steps[stepNumber].workflowStepType,
                previouslyActivatedStep: steps[0].workflowStepType,
                workflowOrigin,
                workflowType,
            };
        },
    ),

    on(WorkflowActions.SetStep, (state, { newStep }): WorkflowState => {
        return { ...state, previouslyActivatedStep: state.activatedStep, activatedStep: newStep.workflowStepType };
    }),

    on(WorkflowActions.SetStepValidity, (state, { isValid, stepType }): WorkflowState => {
        const steps = state.steps.map(step => {
            if (step.workflowStepType === stepType) {
                step = { ...step, isValid };
            }
            return step;
        });
        return { ...state, steps };
    }),
);

export function reducer(state: WorkflowState | undefined, action: Action): WorkflowState {
    return workflowReducer(state, action);
}
